import { Switch } from 'design-system';

import { useLightMode } from '@/shared/lib/LightModeContext';

export const LightModeSwitch = () => {
  const { isLightMode, setIsLightMode } = useLightMode();

  return (
    <div className='flex items-center gap-2 text-sm font-medium'>
      <span>{isLightMode ? 'Light mode' : 'Dark mode'}</span>
      <Switch
        aria-label='Chart appearance'
        checked={!isLightMode}
        onCheckedChange={() => {
          setIsLightMode(value => !value);
        }}
      />
    </div>
  );
};
